export default "__VITE_ASSET__CmmjA6C0__"